function BellCircled() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" fill="none" viewBox="0 0 48 48">
      <circle cx="24" cy="24" r="24" fill="#3C24B3" opacity="0.16"></circle>
      <g clipPath="url(#clip0_15687_3787)">
        <path
          fill="#5D5FEF"
          d="M24 14c-.712 0-1.287.559-1.287 1.25V16c-2.933.578-5.142 3.102-5.142 6.125v.734a7.4 7.4 0 01-1.949 4.985l-.297.324a1.228 1.228 0 00-.213 1.344c.205.449.667.738 1.173.738h15.428c.507 0 .965-.29 1.174-.738a1.22 1.22 0 00-.213-1.344l-.297-.324a7.393 7.393 0 01-1.95-4.985v-.734c0-3.023-2.209-5.547-5.142-6.125v-.75c0-.691-.575-1.25-1.286-1.25zm1.82 19.27a2.466 2.466 0 00.75-1.77H21.429c0 .664.269 1.3.751 1.77A2.61 2.61 0 0024 34a2.61 2.61 0 001.82-.73z"
        ></path>
      </g>
      <defs>
        <clipPath id="clip0_15687_3787">
          <path fill="#fff" d="M0 0H18V20H0z" transform="translate(15 14)"></path>
        </clipPath>
      </defs>
    </svg>
  )
}

export default BellCircled
